var map = {
	"./DarkModeMessage.svg": 2976,
	"./Done.png": 550,
	"./LightModeMessage.svg": 24,
	"./Logomark Black.svg": 5674,
	"./Logomark white.svg": 7100,
	"./Nandana_Workplace.jpg": 5955,
	"./ProductBenefit/b1.png": 243,
	"./ProductBenefit/b2.png": 5667,
	"./ProductBenefit/b3.png": 1594,
	"./ProductBenefit/b4.png": 466,
	"./ProductBenefit/b5.png": 9872,
	"./ProductBenefit/logo192.png": 8074,
	"./ProductBenefit/logo193.png": 2701,
	"./ProductBenefit/tab1.jpeg": 3124,
	"./ProductBenefit/tab2.png": 6022,
	"./ProductBenefit/tab3.png": 2053,
	"./ProductBenefit/tab4.png": 1142,
	"./ProductBenefit/tab5.png": 3938,
	"./Product_Feature_Center_Icon.png": 3609,
	"./Rectangle 20.png": 7967,
	"./Rectangle 21.png": 2511,
	"./Rectangle 22.png": 6078,
	"./Rectangle 23.png": 9662,
	"./Rectangle 24.png": 2868,
	"./Rectangle 25.png": 2995,
	"./Rectangle 26.png": 9892,
	"./Rectangle Black.png": 1933,
	"./Rectangle White.png": 2483,
	"./Rectanlge 25.png": 2898,
	"./TimelineLastShadow.png": 560,
	"./acivesun.png": 3395,
	"./activemoon.png": 622,
	"./advisor_page/Ellipse 1.svg": 5037,
	"./advisor_page/Ellipse 10.svg": 0,
	"./advisor_page/Ellipse 11.svg": 2610,
	"./advisor_page/Ellipse 1@2x.svg": 6889,
	"./advisor_page/Ellipse 2.svg": 6289,
	"./advisor_page/Ellipse 7@2x.svg": 7099,
	"./advisor_page/Ellipse 8.svg": 6181,
	"./advisor_page/Group 1.svg": 8309,
	"./advisor_page/Prithviji_LI.png": 2721,
	"./advisor_page/Prithviji_LI1.png": 5027,
	"./advisor_page/foto-sushi.svg": 9083,
	"./advisor_page/krishnan.png": 3372,
	"./advisor_page/rec.svg": 3688,
	"./advisor_page/sagarphoto.png": 9561,
	"./advisor_page/sushilsir.png": 8936,
	"./advisor_page/sushilsir1.png": 7570,
	"./advisor_page/sushilsir3.png": 3765,
	"./advisor_page/susihilkumar.png": 1288,
	"./advisor_page/susihilkumar12.png": 1305,
	"./anitha_workplace.jpg": 499,
	"./anitha_workplace2.jpg": 1440,
	"./ashwin_workplace.jpg": 5234,
	"./audit.mp4": 3758,
	"./auditlog.mp4": 9087,
	"./back_arrow.png": 1019,
	"./back_arrow_white.png": 8006,
	"./careers_aboutus/Product_colour.svg": 9401,
	"./careers_aboutus/Team Wall Dark.png": 4272,
	"./careers_aboutus/chat_colour.svg": 1094,
	"./careers_aboutus/circle_colour.svg": 3981,
	"./careers_aboutus/code_colour.svg": 3120,
	"./careers_aboutus/down_arrow.gif": 940,
	"./careers_aboutus/down_arrow.svg": 1890,
	"./careers_aboutus/downarrow.png": 7164,
	"./careers_aboutus/handArrowDark.svg": 6783,
	"./careers_aboutus/handArrowLight.svg": 3755,
	"./careers_aboutus/jd_colour.svg": 4763,
	"./careers_aboutus/mail_colou.svg": 873,
	"./careers_aboutus/network_colour.svg": 1175,
	"./careers_aboutus/people_colour.svg": 4434,
	"./careers_aboutus/pride.svg": 4244,
	"./careers_aboutus/pride_color.svg": 8747,
	"./careers_aboutus/product.svg": 1146,
	"./careers_aboutus/sample_potrait.jpg": 3221,
	"./careers_aboutus/sparkle_colour.svg": 8029,
	"./collaboration.svg": 5824,
	"./contact1.1.png": 3844,
	"./contact1.2.png": 8337,
	"./cross.png": 9152,
	"./data-collection.mp4": 3803,
	"./datacollection.mp4": 7162,
	"./developer.png": 8058,
	"./door.png": 206,
	"./esg-agent-preview.mp4": 8963,
	"./esg-agent-preview.png": 1566,
	"./facebook-square.svg": 7961,
	"./fb-wt.svg": 866,
	"./github-bk.png": 9633,
	"./github.png": 9776,
	"./githublightray.svg": 5291,
	"./googleLogo.png": 8084,
	"./impact-framework.mp4": 2937,
	"./impactframework.mp4": 5488,
	"./laptop.png": 141,
	"./light ray.svg": 5716,
	"./linkedin-dk.png": 3834,
	"./linkedin.png": 1654,
	"./login-bgremove.png": 3806,
	"./login.svg": 1134,
	"./logoblack.png": 4896,
	"./logowhite.png": 5887,
	"./manage-users.mp4": 1462,
	"./manageUsers.mp4": 5900,
	"./metric.mp4": 1795,
	"./metrics.mp4": 2962,
	"./mobile-ray.svg": 2744,
	"./moon-dk.svg": 734,
	"./moon-lt.svg": 8233,
	"./next_arrow.png": 3029,
	"./next_arrow_white.png": 549,
	"./not Found.png": 7567,
	"./onboarding.svg": 1558,
	"./onboarding1-bgremove.png": 3280,
	"./opennewtab.png": 9882,
	"./payment.svg": 5197,
	"./payment1-bgremove.png": 6787,
	"./prodredirect.svg": 5745,
	"./product-bgremove.png": 1525,
	"./product.svg": 167,
	"./productfeaturebackground.png": 5294,
	"./productfeaturebackground2.png": 2978,
	"./question_icon.png": 1935,
	"./rahul-workplace.jpg": 689,
	"./rahul-workplace1.jpg": 6431,
	"./rahul_workplace2.jpg": 4523,
	"./reporting.mp4": 7288,
	"./reportingsdg.mp4": 6424,
	"./rightwhitearrow.svg": 1430,
	"./scope2-tool-preview.mp4": 660,
	"./scope2-tool-preview.png": 7952,
	"./spotlight_gradient.png": 9201,
	"./stars.svg": 6911,
	"./stars_dark.svg": 1252,
	"./stars_white.svg": 2994,
	"./sudip_campus.jpg": 5899,
	"./sudip_workplace.jpg": 6798,
	"./sun-lt.svg": 6320,
	"./sun0dk.svg": 2860,
	"./support-bgremove.png": 4172,
	"./support.svg": 8881,
	"./team/Ashwin.jpg": 1040,
	"./twitter-dk.png": 2342,
	"./twitter.png": 3220,
	"./typemarkBlack.svg": 51,
	"./typemarkWhite.svg": 870,
	"./waves-light-color.gif": 8650,
	"./waves-light.gif": 7153,
	"./waves.gif": 382,
	"./waves_color.gif": 6899,
	"./whyDarkMode.svg": 4586
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;